import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";

import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function SetupChargesForm({ formData, submitForm }) {
  const history = useHistory();
  const { handleSubmit, control, reset } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });

  useEffect(() => {
    reset(formData);
  }, [formData]);

  //======================================

  return (
    <form onSubmit={handleSubmit(submitForm)} className="w-100" noValidate>
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <Controller
              control={control}
              name="lookup"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="LookUp"
                  placeholder="LookUp"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="singleColorPrice"
              rules={{ required: true, min: { value: 0 } }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Single Color Price"
                  placeholder="Single Color Price"
                  min={0}
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="multiColorPrice"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Multi Color Price"
                  placeholder="Multi Color Price"
                  min={0}
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default SetupChargesForm;
